// extracted by mini-css-extract-plugin
export default {"hideable":"MenuColumn_hideable__OL07-"};